import { Divider, Skeleton, Stack } from "@mui/joy";
import React from "react";

const styles = { drawingSectionLoadingIndicator: { py: 0.5, px: 1 } };
export default function FloatingRelatedItemsLoadingIndicator() {
    return (
        <Stack spacing={1} divider={<Divider />} sx={{ py: 1 }}>
            <Skeleton
                variant="text"
                level="title-md"
                width="70%"
                sx={styles.drawingSectionLoadingIndicator}
            />
            <Skeleton
                variant="text"
                level="title-md"
                width="50%"
                sx={styles.drawingSectionLoadingIndicator}
            />
            <Skeleton
                variant="text"
                level="title-md"
                width="100%"
                sx={styles.drawingSectionLoadingIndicator}
            />
            <Skeleton
                variant="text"
                level="title-md"
                width="40%"
                sx={styles.drawingSectionLoadingIndicator}
            />
        </Stack>
    );
}
